module.exports = __webpack_public_path__ + "img/banner2.9b6d6ce6.png";